import * as products from 'app/mocks/data/catalogue/products/list'
import * as managers from 'app/mocks/data/park/managers/list'
import * as sites from 'app/mocks/data/park/sites/list'
import * as konvives from 'app/mocks/data/users/konvives/list'

import { newDateFormatted } from 'app/utils/date'

import { Order, StatusOrder } from 'app/types/operations/order'

export const order701: Order = {
    id: 701,
    status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
    konvive: konvives.konvive1,
    site: sites.site1,
    price: 7,
    articles: [
        {
            product: products.product1,
            is_weight_quantity: true,
            quantity: 100,
        },
        {
            product: products.product2,
            is_weight_quantity: true,
            quantity: 500,
        },
        {
            product: products.product3,
            is_weight_quantity: false,
            quantity: 2,
        },
        {
            product: products.product4,
            is_weight_quantity: false,
            quantity: 3,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-20)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive1,
            changes: [
                {
                    product: products.product1,
                    is_weight_quantity: true,
                    quantity: 100,
                },
                {
                    product: products.product2,
                    is_weight_quantity: true,
                    quantity: 500,
                },
                {
                    product: products.product3,
                    is_weight_quantity: false,
                    quantity: 2,
                },
                {
                    product: products.product4,
                    is_weight_quantity: false,
                    quantity: 3,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-20)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager8,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-20)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager8,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-20)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
            author: managers.manager8,
            changes: [],
        },
    ],
}

export const order702: Order = {
    id: 702,
    status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
    konvive: konvives.konvive2,
    site: sites.site1,
    price: 7,
    articles: [
        {
            product: products.product1,
            is_weight_quantity: false,
            quantity: 1,
        },
        {
            product: products.product2,
            is_weight_quantity: false,
            quantity: 1,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-19)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive2,
            changes: [
                {
                    product: products.product1,
                    is_weight_quantity: false,
                    quantity: 1,
                },
                {
                    product: products.product2,
                    is_weight_quantity: false,
                    quantity: 1,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-19)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager3,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-19)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager3,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-19)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
            author: managers.manager3,
            changes: [],
        },
    ],
}

export const order703: Order = {
    id: 703,
    status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
    phone_number: '0632123456',
    site: sites.site2,
    price: 7,
    articles: [
        {
            product: products.product3,
            is_weight_quantity: false,
            quantity: 27,
        },
        {
            product: products.product4,
            is_weight_quantity: false,
            quantity: 2,
        },
        {
            product: products.product5,
            is_weight_quantity: true,
            quantity: 425,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-18)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0632123456',
            changes: [
                {
                    product: products.product3,
                    is_weight_quantity: false,
                    quantity: 27,
                },
                {
                    product: products.product4,
                    is_weight_quantity: false,
                    quantity: 2,
                },
                {
                    product: products.product5,
                    is_weight_quantity: true,
                    quantity: 425,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-18)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager3,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-18)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager3,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-18)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
            author: managers.manager3,
            changes: [],
        },
    ],
}

export const order704: Order = {
    id: 704,
    status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
    konvive: konvives.konvive3,
    site: sites.site3,
    price: 7,
    articles: [
        {
            product: products.product6,
            is_weight_quantity: false,
            quantity: 3,
        },
        {
            product: products.product7,
            is_weight_quantity: false,
            quantity: 55,
        },
        {
            product: products.product8,
            is_weight_quantity: false,
            quantity: 1,
        },
        {
            product: products.product9,
            is_weight_quantity: false,
            quantity: 32,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-17)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive3,
            changes: [
                {
                    product: products.product6,
                    is_weight_quantity: false,
                    quantity: 3,
                },
                {
                    product: products.product7,
                    is_weight_quantity: false,
                    quantity: 55,
                },
                {
                    product: products.product8,
                    is_weight_quantity: false,
                    quantity: 1,
                },
                {
                    product: products.product9,
                    is_weight_quantity: false,
                    quantity: 32,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-17)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager5,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-17)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager5,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-17)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
            author: managers.manager5,
            changes: [],
        },
    ],
}

export const order705: Order = {
    id: 705,
    status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
    phone_number: '0643234567',
    site: sites.site4,
    price: 7,
    articles: [
        {
            product: products.product10,
            is_weight_quantity: true,
            quantity: 400,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-16)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0643234567',
            changes: [
                {
                    product: products.product10,
                    is_weight_quantity: true,
                    quantity: 400,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-16)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager5,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-16)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager5,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-16)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
            author: managers.manager5,
            changes: [],
        },
    ],
}

export const order706: Order = {
    id: 706,
    status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
    konvive: konvives.konvive4,
    site: sites.site5,
    price: 7,
    articles: [
        {
            product: products.product11,
            is_weight_quantity: false,
            quantity: 2,
        },
        {
            product: products.product12,
            is_weight_quantity: false,
            quantity: 47,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-15)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive4,
            changes: [
                {
                    product: products.product11,
                    is_weight_quantity: false,
                    quantity: 2,
                },
                {
                    product: products.product12,
                    is_weight_quantity: false,
                    quantity: 47,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-15)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager2,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-15)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager2,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-15)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
            author: managers.manager2,
            changes: [],
        },
    ],
}

export const order707: Order = {
    id: 707,
    status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
    phone_number: '0654345678',
    site: sites.site6,
    price: 7,
    articles: [
        {
            product: products.product13,
            is_weight_quantity: true,
            quantity: 225,
        },
        {
            product: products.product14,
            is_weight_quantity: false,
            quantity: 4,
        },
        {
            product: products.product15,
            is_weight_quantity: false,
            quantity: 35,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-14)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0654345678',
            changes: [
                {
                    product: products.product13,
                    is_weight_quantity: true,
                    quantity: 225,
                },
                {
                    product: products.product14,
                    is_weight_quantity: false,
                    quantity: 4,
                },
                {
                    product: products.product15,
                    is_weight_quantity: false,
                    quantity: 35,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-14)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager2,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-14)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager2,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-14)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
            author: managers.manager2,
            changes: [],
        },
    ],
}

export const order708: Order = {
    id: 708,
    status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
    konvive: konvives.konvive5,
    site: sites.site7,
    price: 7,
    articles: [
        {
            product: products.product16,
            is_weight_quantity: false,
            quantity: 1,
        },
        {
            product: products.product17,
            is_weight_quantity: false,
            quantity: 60,
        },
        {
            product: products.product18,
            is_weight_quantity: false,
            quantity: 2,
        },
        {
            product: products.product19,
            is_weight_quantity: true,
            quantity: 175,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-13)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive5,
            changes: [
                {
                    product: products.product16,
                    is_weight_quantity: false,
                    quantity: 1,
                },
                {
                    product: products.product17,
                    is_weight_quantity: false,
                    quantity: 60,
                },
                {
                    product: products.product18,
                    is_weight_quantity: false,
                    quantity: 2,
                },
                {
                    product: products.product19,
                    is_weight_quantity: true,
                    quantity: 175,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-13)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager1,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-13)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager1,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-13)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
            author: managers.manager1,
            changes: [],
        },
    ],
}

export const order709: Order = {
    id: 709,
    status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
    phone_number: '0665456789',
    site: sites.site8,
    price: 7,
    articles: [
        {
            product: products.product20,
            is_weight_quantity: true,
            quantity: 525,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-12)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0665456789',
            changes: [
                {
                    product: products.product20,
                    is_weight_quantity: true,
                    quantity: 525,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-12)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager1,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-12)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager1,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-12)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
            author: managers.manager1,
            changes: [],
        },
    ],
}

export const order710: Order = {
    id: 710,
    status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
    konvive: konvives.konvive6,
    site: sites.site9,
    price: 7,
    articles: [
        {
            product: products.product21,
            is_weight_quantity: false,
            quantity: 3,
        },
        {
            product: products.product22,
            is_weight_quantity: false,
            quantity: 45,
        },
        {
            product: products.product23,
            is_weight_quantity: false,
            quantity: 3,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-11)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive6,
            changes: [
                {
                    product: products.product21,
                    is_weight_quantity: false,
                    quantity: 3,
                },
                {
                    product: products.product22,
                    is_weight_quantity: false,
                    quantity: 45,
                },
                {
                    product: products.product23,
                    is_weight_quantity: false,
                    quantity: 3,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-11)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager7,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-11)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager7,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-11)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
            author: managers.manager7,
            changes: [],
        },
    ],
}

export const order711: Order = {
    id: 711,
    status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
    phone_number: '0676567890',
    site: sites.site10,
    price: 7,
    articles: [
        {
            product: products.product24,
            is_weight_quantity: false,
            quantity: 37,
        },
        {
            product: products.product1,
            is_weight_quantity: false,
            quantity: 2,
        },
        {
            product: products.product2,
            is_weight_quantity: true,
            quantity: 250,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-10)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0676567890',
            changes: [
                {
                    product: products.product24,
                    is_weight_quantity: false,
                    quantity: 37,
                },
                {
                    product: products.product1,
                    is_weight_quantity: false,
                    quantity: 2,
                },
                {
                    product: products.product2,
                    is_weight_quantity: true,
                    quantity: 250,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-10)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager7,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-10)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager7,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-10)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
            author: managers.manager7,
            changes: [],
        },
    ],
}

export const order712: Order = {
    id: 712,
    status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
    konvive: konvives.konvive7,
    site: sites.site11,
    price: 7,
    articles: [
        {
            product: products.product3,
            is_weight_quantity: false,
            quantity: 4,
        },
        {
            product: products.product4,
            is_weight_quantity: false,
            quantity: 42,
        },
        {
            product: products.product5,
            is_weight_quantity: true,
            quantity: 575,
        },
        {
            product: products.product6,
            is_weight_quantity: false,
            quantity: 1,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-9)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive7,
            changes: [
                {
                    product: products.product3,
                    is_weight_quantity: false,
                    quantity: 4,
                },
                {
                    product: products.product4,
                    is_weight_quantity: false,
                    quantity: 42,
                },
                {
                    product: products.product5,
                    is_weight_quantity: true,
                    quantity: 575,
                },
                {
                    product: products.product6,
                    is_weight_quantity: false,
                    quantity: 1,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-9)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager6,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-9)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager6,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-9)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
            author: managers.manager6,
            changes: [],
        },
    ],
}

export const order713: Order = {
    id: 713,
    status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
    phone_number: '0687678901',
    site: sites.site12,
    price: 7,
    articles: [
        {
            product: products.product7,
            is_weight_quantity: false,
            quantity: 32,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-8)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0687678901',
            changes: [
                {
                    product: products.product7,
                    is_weight_quantity: false,
                    quantity: 32,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-8)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager6,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-8)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager6,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-8)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
            author: managers.manager6,
            changes: [],
        },
    ],
}

export const order714: Order = {
    id: 714,
    status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
    konvive: konvives.konvive8,
    site: sites.site13,
    price: 7,
    articles: [
        {
            product: products.product8,
            is_weight_quantity: false,
            quantity: 2,
        },
        {
            product: products.product9,
            is_weight_quantity: false,
            quantity: 47,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-7)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive8,
            changes: [
                {
                    product: products.product8,
                    is_weight_quantity: false,
                    quantity: 2,
                },
                {
                    product: products.product9,
                    is_weight_quantity: false,
                    quantity: 47,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-7)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager4,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-7)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager4,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-7)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
            author: managers.manager4,
            changes: [],
        },
    ],
}

export const order715: Order = {
    id: 715,
    status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
    phone_number: '0698789012',
    site: sites.site14,
    price: 7,
    articles: [
        {
            product: products.product10,
            is_weight_quantity: true,
            quantity: 200,
        },
        {
            product: products.product11,
            is_weight_quantity: false,
            quantity: 3,
        },
        {
            product: products.product12,
            is_weight_quantity: false,
            quantity: 5,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-6)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0698789012',
            changes: [
                {
                    product: products.product10,
                    is_weight_quantity: true,
                    quantity: 200,
                },
                {
                    product: products.product11,
                    is_weight_quantity: false,
                    quantity: 3,
                },
                {
                    product: products.product12,
                    is_weight_quantity: false,
                    quantity: 5,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-6)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager4,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-6)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager4,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-6)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
            author: managers.manager4,
            changes: [],
        },
    ],
}

export const order716: Order = {
    id: 716,
    status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
    konvive: konvives.konvive9,
    site: sites.site15,
    price: 7,
    articles: [
        {
            product: products.product13,
            is_weight_quantity: false,
            quantity: 1,
        },
        {
            product: products.product14,
            is_weight_quantity: false,
            quantity: 4,
        },
        {
            product: products.product15,
            is_weight_quantity: false,
            quantity: 27,
        },
        {
            product: products.product16,
            is_weight_quantity: false,
            quantity: 2,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-5)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive9,
            changes: [
                {
                    product: products.product13,
                    is_weight_quantity: false,
                    quantity: 1,
                },
                {
                    product: products.product14,
                    is_weight_quantity: false,
                    quantity: 4,
                },
                {
                    product: products.product15,
                    is_weight_quantity: false,
                    quantity: 27,
                },
                {
                    product: products.product16,
                    is_weight_quantity: false,
                    quantity: 2,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-5)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager9,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-5)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager9,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-5)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
            author: managers.manager9,
            changes: [],
        },
    ],
}

export const order717: Order = {
    id: 717,
    status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
    phone_number: '0609890123',
    site: sites.site16,
    price: 7,
    articles: [
        {
            product: products.product17,
            is_weight_quantity: false,
            quantity: 62,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-4)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0609890123',
            changes: [
                {
                    product: products.product17,
                    is_weight_quantity: false,
                    quantity: 62,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-4)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager9,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-4)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager9,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-4)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
            author: managers.manager9,
            changes: [],
        },
    ],
}

export const order718: Order = {
    id: 718,
    status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
    konvive: konvives.konvive10,
    site: sites.site17,
    price: 7,
    articles: [
        {
            product: products.product18,
            is_weight_quantity: false,
            quantity: 3,
        },
        {
            product: products.product19,
            is_weight_quantity: true,
            quantity: 350,
        },
        {
            product: products.product20,
            is_weight_quantity: true,
            quantity: 225,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-3)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive10,
            changes: [
                {
                    product: products.product18,
                    is_weight_quantity: false,
                    quantity: 3,
                },
                {
                    product: products.product19,
                    is_weight_quantity: true,
                    quantity: 350,
                },
                {
                    product: products.product20,
                    is_weight_quantity: true,
                    quantity: 225,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-3)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager10,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-3)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager10,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-3)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
            author: managers.manager10,
            changes: [],
        },
    ],
}

export const order719: Order = {
    id: 719,
    status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
    phone_number: '0610901234',
    site: sites.site18,
    price: 7,
    articles: [
        {
            product: products.product21,
            is_weight_quantity: false,
            quantity: 5,
        },
        {
            product: products.product22,
            is_weight_quantity: false,
            quantity: 2,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-2)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0610901234',
            changes: [
                {
                    product: products.product21,
                    is_weight_quantity: false,
                    quantity: 5,
                },
                {
                    product: products.product22,
                    is_weight_quantity: false,
                    quantity: 2,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-2)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager10,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-2)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager10,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-2)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
            author: managers.manager10,
            changes: [],
        },
    ],
}

export const order720: Order = {
    id: 720,
    status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
    konvive: konvives.konvive1,
    site: sites.site19,
    price: 7,
    articles: [
        {
            product: products.product23,
            is_weight_quantity: false,
            quantity: 4,
        },
        {
            product: products.product24,
            is_weight_quantity: false,
            quantity: 1,
        },
        {
            product: products.product1,
            is_weight_quantity: true,
            quantity: 300,
        },
        {
            product: products.product2,
            is_weight_quantity: false,
            quantity: 3,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-1)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive1,
            changes: [
                {
                    product: products.product23,
                    is_weight_quantity: false,
                    quantity: 4,
                },
                {
                    product: products.product24,
                    is_weight_quantity: false,
                    quantity: 1,
                },
                {
                    product: products.product1,
                    is_weight_quantity: true,
                    quantity: 300,
                },
                {
                    product: products.product2,
                    is_weight_quantity: false,
                    quantity: 3,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-1)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager8,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-1)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager8,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-1)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED_BY_SOMEONE_ELSE,
            author: managers.manager8,
            changes: [],
        },
    ],
}
